import(/* webpackMode: "eager" */ "/home/lb17/rc_324_lb91_minarca_backup/wts_cms_v1/WTS-admin-pannel/src/app/admin/page.tsx");
